import { OutcomeEnum } from "../../Enums/OutcomeEnum";

export default class ResultModel {
    public settledAt: string = null;
    public resettledAt: string = null;
    public status: string = null;
    public outcome: OutcomeEnum = null;
    public points: number = 0;
}